var tagStyles = {
  "tag_input": "Base-InputTag--TagInput",
  "wrapper": "Base-InputTag--Wrapper",
  "tag_wrapper": "Base-InputTag--TagWrapper",
  "tag": "Base-InputTag--Tag",
  "clear": "Base-InputTag--Clear",
  "tag_content": "Base-InputTag--TagContent",
  "has_clear": "Base-InputTag--HasClear",
  "suffix": "Base-InputTag--Suffix"
};

export { tagStyles as default };
